import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-fullscreen"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "xmodal" }
const _hoisted_4 = {
  key: 1,
  class: "xmodal-description"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { class: "xmodal-changes" }
const _hoisted_8 = ["position"]
const _hoisted_9 = ["onClick", "disabled"]
const _hoisted_10 = { class: "button-text" }
const _hoisted_11 = ["position"]

import { computed, watch, ref } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { useStore } from "vuex";
import useHtmlUtilities from "@/use/htmlUtilities";
import { ModalTypes } from "@/models/modal";


export default /*@__PURE__*/_defineComponent({
  __name: 'OpalModal',
  setup(__props, { expose: __expose }) {

const store = useStore();
const modalActive = ref<boolean>(false);

const modalState = computed(() => store.state.modal);

const allowClose = computed<boolean>(() => store.state.modal.allowClose ?? true);

const { isColorDark } = useHtmlUtilities();

const isDarkBrand = computed(() => isColorDark(store.state.lenderData?.primaryColor || "#000000"));

watch(
  () => store.state.modal.active,
  value => {
    modalActive.value = value;
  },
  { deep: true },
);

function closeModal() {
  const body = document.querySelector("body");
  if (body) {
    body.style.overflow = "visible";
  }
  store.dispatch("modal/setCountDownModal", 0);
  store.dispatch("modal/closeModal");
}

__expose({
  modalState,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      (modalActive.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["xmodal-wrapper", [
        `text-align-${_unref(store).state.modal.textAlign}`,
        { 'xform-changes-modal': _unref(store).state.modal.type === _unref(ModalTypes).FormChanges },
      ]]),
            id: "opal-modal",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (allowClose.value && closeModal), ["self"]))
          }, [
            _createElementVNode("div", {
              class: "xmodal-inner",
              "data-fullscreen": _unref(store).state.modal.fullscreen
            }, [
              (allowClose.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "xmodal-close-icon",
                    onClick: closeModal,
                    disabled: _unref(store).state.modal.closeBtnDisabled
                  }, [
                    _createVNode(_unref(FontAwesomeIcon), {
                      icon: "fa-solid fa-x",
                      size: "xl"
                    })
                  ], 8, _hoisted_2))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_3, [
                (_unref(store).state.modal.title)
                  ? (_openBlock(), _createElementBlock("h2", {
                      key: 0,
                      class: _normalizeClass(["xmodal-title", _unref(store).state.modal.titleClassList || []])
                    }, _toDisplayString(_unref(store).state.modal.title), 3))
                  : _createCommentVNode("", true),
                (_unref(store).state.modal.description)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(store).state.modal.description), 1))
                  : _createCommentVNode("", true),
                (_unref(store).state.modal.html)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      innerHTML: _unref(store).state.modal.html,
                      class: "xmodal-html"
                    }, null, 8, _hoisted_5))
                  : _createCommentVNode("", true),
                (_unref(store).state.modal.changes && _unref(store).state.modal.changes.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("table", _hoisted_7, [
                        _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
                          _createElementVNode("th"),
                          _createElementVNode("th", { id: "old" }, "Previous"),
                          _createElementVNode("th", { id: "new" }, "New")
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.modal.changes, (change, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", null, _toDisplayString(change.label), 1),
                              _createElementVNode("td", null, _toDisplayString(change.before), 1),
                              _createElementVNode("td", null, _toDisplayString(change.after), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(store).state.modal.buttons.length > 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 4,
                      class: _normalizeClass(["xmodal-buttons", [
              {
                'center-buttons': _unref(store).state.modal.centerButtons,
              },
            ]]),
                      position: _unref(store).state.modal.buttonsPosition || ''
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.modal.buttons, (button, index) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: index,
                          class: _normalizeClass([
                { loading: button?.loading },
                { 'branded-button': isDarkBrand.value && !button.isCancel },
                button.classStyle,
              ]),
                          style: _normalizeStyle(
                !button.isCancel ? { backgroundColor: _unref(store).state.lenderData.primaryColor } : {}
              ),
                          onClick: ($event: any) => (button.onClick ? button.onClick() : closeModal),
                          disabled: button?.loading || false
                        }, [
                          _createElementVNode("span", _hoisted_10, _toDisplayString(button.title), 1)
                        ], 14, _hoisted_9))
                      }), 128))
                    ], 10, _hoisted_8))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 5,
                      class: "xmodal-buttons",
                      position: _unref(store).state.modal.buttonsPosition || ''
                    }, [
                      _createElementVNode("button", {
                        class: "primary-btn",
                        onClick: closeModal
                      }, "Close")
                    ], 8, _hoisted_11))
              ])
            ], 8, _hoisted_1)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})